import { apiClient } from "../config";

async function addDataPortal(body: any): Promise<any> {
  const res = await apiClient.post(`/admin/data-portals`, body);
  return res.data;
}

export default addDataPortal;